var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeTab(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "26px",
    height: "26px",
    viewBox: "0 0 26 26",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "home_02") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u9875\\u9762-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PC\\u5207\\u56FE",
    transform: "translate(-33.000000, -149.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-15-Copy",
    transform: "translate(33.000000, 149.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5,3 C16.3994949,3 19.0244949,4.17525253 20.9246212,6.0753788 C22.8247475,7.97550506 24,10.6005051 24,13.5 C24,16.3994949 22.8247475,19.0244949 20.9246212,20.9246212 C19.0244949,22.8247475 16.3994949,24 13.5,24 C12.0729495,24 10.7123067,23.7156187 9.47191784,23.1998793 C9.19285754,23.0838492 8.27714111,22.9945143 7.20546167,22.9409959 L7.20546167,22.9409959 L6.27074653,22.8910664 C5.45798319,22.8420233 4.53788674,22.9244189 4.32596956,22.7136211 C4.02141915,22.4106793 4.13193508,20.8897627 4.07191065,19.7760028 C4.0147968,18.7162488 3.92323065,17.8222156 3.80996404,17.5516744 C3.2880036,16.3049542 3,14.9361036 3,13.5 C3,10.6005051 4.17525253,7.97550506 6.0753788,6.0753788 C7.97550506,4.17525253 10.6005051,3 13.5,3 Z",
    id: "Oval-14",
    stroke: "#F3CDC2",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62\\u5907\\u4EFD-7",
    fill: "#FFFFFF",
    opacity: 0,
    x: 0,
    y: 0,
    width: 26,
    height: 26
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeTab);
export default __webpack_public_path__ + "static/media/HomeTab.d7a29ab37ad29cd5a6f355cf7a100a2b.svg";
export { ForwardRef as ReactComponent };